import { useEffect, useRef } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';

import { Seo } from 'src/components/seo';
import { logoutUser } from 'src/routes/AuthContext';
import authService from 'src/services/apiServices/authService';

/**
 * APIT-696 — lands here from the emailed magic link after the user sets a new password on
 * Keycloak's update-password page, with a fresh SSO session.
 *
 * On mount: POST /user/forgot-password/complete (authenticated, through the normal interceptor).
 * That call sends the "your password was changed" confirmation email and signs the user out of
 * every other Keycloak session server-side (AC 10, 11). Whether it succeeds or fails, this page
 * then signs the CURRENT session out too via the app's existing logout mechanism, so the user
 * always lands back on the Keycloak login page to sign in with the new password rather than being
 * left sitting here.
 */
const Page = () => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const complete = async () => {
      try {
        await authService.completeForgotPassword();
      } catch (err) {
        console.error(err);
      } finally {
        logoutUser();
      }
    };

    complete();
  }, []);

  return (
    <>
      <Seo title="Password Changed" />
      <div>
        <Card elevation={16}>
          <CardHeader
            sx={{ pb: 0 }}
            title="Password changed"
          />
          <CardContent>
            <Typography>
              Your password has been changed. Signing you out so you can log in with your new
              password&hellip;
            </Typography>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default Page;
